import { Component } from "react";
import Markdown from "../../../utilities/Markdown";

export default class AlertComponent extends Component<{ message: string }> {
  render() {
    const { message } = this.props;

    return <Markdown source={message} withStyles={true} />;
  }
}
